(function () {
  'use strict';

  if (window.DuxbuxKitCartGroups) return;
  window.DuxbuxKitCartGroups = true;

  var MINIMUM_TIER_UNITS = 4;
  var activeRemovals = new Set();

  function closestElement(target, selector) {
    return target instanceof Element ? target.closest(selector) : null;
  }

  function kitRows(cartItems, kitId) {
    return Array.from(cartItems.querySelectorAll('.cart-item[data-kit-id]')).filter(
      function (row) {
        return row.dataset.kitId === kitId;
      }
    );
  }

  function rowQuantity(row) {
    var input = row.querySelector('.qty-input__input');
    var quantity = input ? Number(input.value) : 0;
    return Number.isFinite(quantity) ? Math.max(quantity, 0) : 0;
  }

  function coreUnitCount(rows) {
    return rows.reduce(function (total, row) {
      return row.dataset.kitTierRole === 'core' ? total + rowQuantity(row) : total;
    }, 0);
  }

  function preventCartItemUpdate(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function statusElements(cartItems, kitId) {
    return Array.from(cartItems.querySelectorAll('[data-kit-remove-status]')).filter(
      function (status) {
        return status.dataset.kitRemoveStatus === kitId;
      }
    );
  }

  function removeButtons(cartItems, kitId) {
    return Array.from(cartItems.querySelectorAll('[data-remove-kit]')).filter(
      function (button) {
        return button.dataset.removeKit === kitId;
      }
    );
  }

  function setRemovingState(cartItems, kitId, isRemoving) {
    cartItems.classList.toggle('pointer-events-none', isRemoving);

    removeButtons(cartItems, kitId).forEach(function (button) {
      if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent.trim();
      button.disabled = isRemoving;
      button.textContent = isRemoving ? 'Removing…' : button.dataset.defaultLabel;
    });

    statusElements(cartItems, kitId).forEach(function (status) {
      status.textContent = isRemoving ? 'Removing your complete kit…' : '';
      if (isRemoving) status.setAttribute('role', 'status');
      status.hidden = !isRemoving;
    });
  }

  function showRemovalError(cartItems, kitId, error) {
    var message = error && error.message ? error.message : 'The kit could not be removed. Try again.';
    var statuses = statusElements(cartItems, kitId);
    var fallback = cartItems.querySelector('.cart-errors, .cart-item__error');

    if (statuses.length) {
      statuses.forEach(function (status) {
        status.textContent = message;
        status.setAttribute('role', 'alert');
        status.hidden = false;
      });
    } else if (fallback) {
      fallback.textContent = message;
      fallback.hidden = false;
    }

    cartItems.dispatchEvent(
      new CustomEvent('on:cart:error', {
        bubbles: true,
        detail: { error: message }
      })
    );
  }

  function responseError(payload, status) {
    if (typeof payload.errors === 'string') return payload.errors;
    if (typeof payload.description === 'string') return payload.description;
    var themeError = window.theme && window.theme.strings
      ? window.theme.strings.cartError
      : '';
    return /^[0-9]+$/.test(String(status)) && themeError
      ? themeError
      : 'The kit could not be removed. Try again.';
  }

  async function refreshAfterRemoval(cartItems) {
    var cartDrawer = cartItems.closest('cart-drawer');
    var mainCart = document.querySelector('.cc-main-cart cart-items');

    if (!cartDrawer || mainCart) {
      window.location.reload();
      return;
    }

    await cartDrawer.refresh(true);
    var focusTarget = cartDrawer.querySelector('.js-item-name, .js-cart-empty a');
    if (focusTarget) focusTarget.focus();
  }

  async function removeKit(cartItems, kitId) {
    if (!cartItems || !kitId || activeRemovals.has(kitId)) return;

    var rows = kitRows(cartItems, kitId);
    var updates = {};
    rows.forEach(function (row) {
      if (row.dataset.lineKey) updates[row.dataset.lineKey] = 0;
    });

    if (!Object.keys(updates).length) {
      showRemovalError(cartItems, kitId, new Error('The kit could not be identified. Refresh and try again.'));
      return;
    }

    activeRemovals.add(kitId);
    setRemovingState(cartItems, kitId, true);

    try {
      var route = window.theme && window.theme.routes
        ? window.theme.routes.cartUpdate
        : '/cart/update.js';
      var response = await fetch(route, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      });
      var cart = await response.json().catch(function () {
        return {};
      });

      if (!response.ok) throw new Error(responseError(cart, response.status));

      cartItems.dispatchEvent(
        new CustomEvent('on:line-item:change', {
          bubbles: true,
          detail: { cart: cart, kitId: kitId, removedKit: true }
        })
      );
      await refreshAfterRemoval(cartItems);
      activeRemovals.delete(kitId);
      if (cartItems.isConnected) setRemovingState(cartItems, kitId, false);
    } catch (error) {
      activeRemovals.delete(kitId);
      setRemovingState(cartItems, kitId, false);
      showRemovalError(cartItems, kitId, error);
      console.error(error);
    }
  }

  function handleClick(event) {
    var groupButton = closestElement(event.target, '[data-remove-kit]');
    if (groupButton) {
      var groupCartItems = groupButton.closest('cart-items');
      preventCartItemUpdate(event);
      removeKit(groupCartItems, groupButton.dataset.removeKit);
      return;
    }

    var removeLink = closestElement(event.target, '.js-remove-item');
    var removeRow = removeLink ? removeLink.closest('.cart-item[data-kit-id]') : null;
    if (removeRow) {
      preventCartItemUpdate(event);
      removeKit(removeRow.closest('cart-items'), removeRow.dataset.kitId);
      return;
    }

    var minusButton = closestElement(event.target, '.qty-input__btn[name="minus"]');
    var minusRow = minusButton ? minusButton.closest('.cart-item[data-kit-id]') : null;
    if (!minusRow) return;

    var cartItems = minusRow.closest('cart-items');
    var projectedCoreUnits = coreUnitCount(kitRows(cartItems, minusRow.dataset.kitId));
    if (minusRow.dataset.kitTierRole === 'core') projectedCoreUnits -= 1;
    if (projectedCoreUnits >= MINIMUM_TIER_UNITS) return;

    preventCartItemUpdate(event);
    removeKit(cartItems, minusRow.dataset.kitId);
  }

  function handleChange(event) {
    var input = closestElement(event.target, '.qty-input__input');
    var row = input ? input.closest('.cart-item[data-kit-id]') : null;
    if (!row) return;

    var cartItems = row.closest('cart-items');
    if (coreUnitCount(kitRows(cartItems, row.dataset.kitId)) >= MINIMUM_TIER_UNITS) return;

    preventCartItemUpdate(event);
    removeKit(cartItems, row.dataset.kitId);
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('change', handleChange, true);
})();
